import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { SiteService } from './service/site.service';
import { Site } from './type/site';

@Injectable()
export class SiteResolver implements Resolve<Site[]> {
  constructor(private siteService: SiteService) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<Site[]> {
    return this.siteService.fetchAllowedSites();
  }
}
